import { BiChevronDown } from "react-icons/bi";
import Button from "../button/Button";
import { Card } from "../Card";
import { TransactionBadge } from "../TransactionBadge";
import clsx from "clsx";
import { motion } from "framer-motion";

export const SuccessModal = ({ action, transaction, onClick }) => {
  return (
    <motion.div
      initial={{ y: "100%" }}
      animate={{ y: 0 }}
      exit={{ y: "100%" }}
      transition={{
        type: "tween",
        duration: 0.4,
        ease: [0.4, 0.0, 0.2, 1],
      }}
      className={clsx(
        "fixed h-full inset-x-0 bottom-0 z-[4000] bg-[#F8F8F8]  480:max-w-[440px] 480:mx-auto ",
      )}
    >
      <div className="px-4 pt-10 relative">
        <div className="flex flex-col items-center justify-center mb-5">
          <Check />
          <p className="text-2xl text-primary-black font-semibold mt-5">{`${action} Successful!`}</p>
        </div>
        <Card className="my-12 flex flex-col gap-5">
          <div className="flex justify-between">
            <span className="text-xs font-normal text-[#000000BF]">
              References Number
            </span>
            <span className="text-xs font-normal text-primary-black">
              {transaction?.reference}
            </span>
          </div>

          <div className="flex justify-between">
            <span className="text-xs font-normal text-[#000000BF]">
              Transaction Status
            </span>
            <TransactionBadge status={transaction?.status} />
          </div>

          <div className="flex justify-between">
            <span className="text-xs font-normal text-[#000000BF]">
              Transaction Time
            </span>
            <span className="text-xs font-normal text-primary-black">
              {transaction?.time}
            </span>
          </div>

          <div className="flex justify-between">
            <span className="text-xs font-normal text-[#000000BF]">
              Payment Method
            </span>
            <span className="text-xs font-normal text-primary-black">
              {transaction?.paymentMethod}
            </span>
          </div>

          {transaction?.creditedTo && (
            <div className="flex justify-between">
              <span className="text-xs font-normal text-[#000000BF]">
                Credited to
              </span>
              <span className="text-xs font-normal text-primary-black">
                {transaction?.creditedTo}
              </span>
            </div>
          )}
          {transaction?.bank && (
            <div className="flex justify-between">
              <span className="text-xs font-normal text-[#000000BF]">Bank</span>
              <span className="text-xs font-normal text-primary-black">
                {transaction?.bank}
              </span>
            </div>
          )}

          {transaction?.amount && (
            <div className="flex justify-between">
              <span className="text-xs font-normal text-[#000000BF]">
                Amount
              </span>
              <span className="text-xs font-normal text-primary-black">
                {transaction?.amount}
              </span>
            </div>
          )}

          {transaction?.recipientMobile && (
            <div className="flex justify-between">
              <span className="text-xs font-normal text-[#000000BF]">
                Recipient Mobile
              </span>
              <span className="text-xs font-normal text-primary-black">
                {transaction.recipientMobile}
              </span>
            </div>
          )}

          {transaction?.transactionType && (
            <div className="flex justify-between">
              <span className="text-xs font-normal text-[#000000BF]">
                Transaction Type
              </span>
              <span className="text-xs font-normal text-primary-black">
                {transaction?.transactionType}
              </span>
            </div>
          )}
        </Card>

        <Card className="flex items-center justify-between gap-3 !py-2.5 !pl-2.5 !pr-7 cursor-pointer mb-5">
          <div className="flex items-center gap-2.5">
            <Locate />
            <div>
              <p className="text-base font-semibold text-black mb-1">
                Trouble with your redeeming?
              </p>
              <p className="text-xs font-medium text-[#00000080] leading-tight">
                Let us know on help center now!
              </p>
            </div>
          </div>

          <BiChevronDown className="-rotate-90 text-[#00000080]" />
        </Card>
        <Button
          onClick={onClick}
          text="Done"
          className="!py-4 !rounded-[50px] "
        />
      </div>
    </motion.div>
  );
};

const Check = () => {
  return (
    <svg
      width="81"
      height="80"
      viewBox="0 0 81 80"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M40.5003 73.3333C22.0903 73.3333 7.16699 58.41 7.16699 40C7.16699 21.59 22.0903 6.66667 40.5003 6.66667C58.9103 6.66667 73.8336 21.59 73.8336 40C73.8336 58.41 58.9103 73.3333 40.5003 73.3333ZM36.577 47.1333L27.3603 37.91L23.8337 41.4367L34.2303 51.84C34.8554 52.4649 35.7031 52.816 36.587 52.816C37.4709 52.816 38.3186 52.4649 38.9437 51.84L58.7837 32.0067L55.2437 28.4667L36.577 47.1333Z"
        fill="#21AC51"
      />
    </svg>
  );
};

const Locate = () => {
  return (
    <svg
      width="48"
      height="48"
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="48" height="48" rx="5" fill="#ECEFFF" />
      <path
        d="M23.9996 29.4C23.3962 29.4001 22.815 29.173 22.3715 28.7638C21.9281 28.3546 21.6551 27.7934 21.6068 27.192C20.0062 26.6255 18.6573 25.5117 17.798 24.0472C16.9388 22.5828 16.6246 20.8619 16.9108 19.1883C17.197 17.5147 18.0652 15.9961 19.3623 14.9004C20.6593 13.8047 22.3017 13.2025 23.9996 13.2C25.8055 13.1998 27.5455 13.8781 28.8747 15.1006C30.2039 16.3231 31.0251 18.0004 31.1756 19.8C31.1806 19.8781 31.1693 19.9563 31.1425 20.0298C31.1156 20.1033 31.0738 20.1703 31.0196 20.2268C30.9655 20.2832 30.9001 20.3277 30.8278 20.3575C30.7555 20.3874 30.6778 20.4018 30.5996 20.4C30.4389 20.396 30.2854 20.3323 30.1689 20.2215C30.0525 20.1106 29.9815 19.9604 29.9696 19.8C29.8627 18.739 29.475 17.7257 28.8464 16.8643C28.2178 16.0029 27.3709 15.3247 26.393 14.8993C25.4152 14.474 24.3416 14.3169 23.2829 14.4443C22.2242 14.5718 21.2185 14.979 20.3695 15.6243C19.5205 16.2695 18.8587 17.1293 18.4524 18.1152C18.0461 19.1011 17.9099 20.1775 18.0578 21.2336C18.2057 22.2897 18.6324 23.2872 19.294 24.1236C19.9555 24.9599 20.828 25.6049 21.8216 25.992C22.0024 25.6014 22.2849 25.2665 22.6396 25.0226C22.9943 24.7786 23.408 24.6346 23.8375 24.6055C24.267 24.5764 24.6964 24.6634 25.0807 24.8573C25.4651 25.0512 25.7901 25.3449 26.022 25.7076C26.2538 26.0703 26.3838 26.4887 26.3983 26.9189C26.4128 27.3491 26.3114 27.7754 26.1046 28.1529C25.8978 28.5305 25.5933 28.8454 25.223 29.0648C24.8526 29.2843 24.4301 29.4 23.9996 29.4ZM18.0104 26.4H18.1196C18.5876 26.8572 19.1072 27.2604 19.67 27.6H18.0104C17.3372 27.6 16.7996 28.1364 16.7996 28.8C16.7996 30.3708 17.546 31.5408 18.8072 32.3436C20.0912 33.1632 21.9176 33.6 23.9996 33.6C26.0816 33.6 27.908 33.1632 29.192 32.3436C30.452 31.5396 31.1996 30.372 31.1996 28.8C31.1996 28.4818 31.0732 28.1765 30.8481 27.9515C30.6231 27.7264 30.3179 27.6 29.9996 27.6H27.5504C27.6175 27.2028 27.6175 26.7972 27.5504 26.4H29.9996C30.6361 26.4 31.2466 26.6529 31.6967 27.103C32.1468 27.553 32.3996 28.1635 32.3996 28.8C32.3996 30.8292 31.4 32.3592 29.8376 33.3564C28.2992 34.3368 26.2256 34.8 23.9996 34.8C21.7736 34.8 19.7 34.3368 18.1616 33.3564C16.5992 32.3604 15.5996 30.828 15.5996 28.8C15.5996 27.4644 16.6832 26.4 18.0104 26.4ZM28.7996 20.4C28.7999 21.212 28.5941 22.0107 28.2017 22.7216C27.8092 23.4324 27.2429 24.032 26.5556 24.4644C26.2353 24.1414 25.8566 23.882 25.4396 23.7C26.1976 23.3692 26.8186 22.7874 27.1982 22.0526C27.5777 21.3178 27.6926 20.4747 27.5237 19.665C27.3547 18.8554 26.9121 18.1287 26.2703 17.607C25.6285 17.0853 24.8267 16.8006 23.9996 16.8006C23.1725 16.8006 22.3707 17.0853 21.7289 17.607C21.0871 18.1287 20.6445 18.8554 20.4755 19.665C20.3066 20.4747 20.4215 21.3178 20.8011 22.0526C21.1806 22.7874 21.8016 23.3692 22.5596 23.7C22.1396 23.8836 21.7616 24.144 21.4436 24.4644C20.5321 23.8912 19.8398 23.0282 19.478 22.014C19.2934 21.4959 19.1993 20.95 19.1996 20.4C19.1996 19.127 19.7053 17.9061 20.6055 17.0059C21.5057 16.1057 22.7266 15.6 23.9996 15.6C25.2726 15.6 26.4935 16.1057 27.3937 17.0059C28.2939 17.9061 28.7996 19.127 28.7996 20.4Z"
        fill="#2741D6"
      />
    </svg>
  );
};
